import { useMemo } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'ramda/src/isEmpty'
import { useRouter } from 'next/router'
import { category } from '#proptypes'
import LocaleLink from '#src/common/components/locale-link'
import { Collapsible } from '#src/products/components/collapsible-section'
import { CategoryLink } from './category-link'
import { SubMenu, SubMenuButton, SubMenuItem, SubMenuLink } from './styles'
import { getQueryAllergen } from '#src/products/product-category-page/get-products-by-category'

export const Categories = ({ categories, selectedIndex }) => {
  const { query } = useRouter()

  const categoriesWithQuery = useMemo(() => {
    let allergens = query?.allergens
    let suitables = query?.suitables

    if (!allergens && !suitables) {
      return categories
    }

    return categories.map(category => {
      if (isEmpty(category.subcategories)) {
        let as = getQueryAllergen(query)
        as = `${category.link.as}${as}`
        return {
          ...category,
          link: {
            ...category.link,
            as
          }
        }
      }

      const subcategories = category.subcategories.map(subcategory => {
        let as = getQueryAllergen(query)
        as = `${subcategory.link.as}${as}`
        return {
          ...subcategory,
          link: {
            ...subcategory.link,
            as
          }
        }
      })

      return {
        ...category,
        subcategories
      }
    })
  }, [categories, query])

  return (
    <Collapsible
      as='nav'
      id='collapsible-subcategories'
      data-testid='category-nav'
      defaultIndex={selectedIndex}
    >
      {categoriesWithQuery.map((category, index) => (
        <Collapsible.Item index={index} key={category.id}>
          {isEmpty(category.subcategories) ? (
            <Collapsible.Header level={4}>
              <Collapsible.Button as={CategoryLink} link={category.link}>
                {category.name}
              </Collapsible.Button>
            </Collapsible.Header>
          ) : (
            <>
              <Collapsible.Header level={4}>
                <SubMenuButton>{category.name}</SubMenuButton>
              </Collapsible.Header>
              <Collapsible.Panel>
                <SubMenu data-testid='category-sub-nav'>
                  {category.subcategories.map(subcategory => (
                    <SubMenuItem key={subcategory.id}>
                      <LocaleLink
                        href={subcategory.link.href}
                        as={subcategory.link.as}
                      >
                        <SubMenuLink>{subcategory.name}</SubMenuLink>
                      </LocaleLink>
                    </SubMenuItem>
                  ))}
                </SubMenu>
              </Collapsible.Panel>
            </>
          )}
        </Collapsible.Item>
      ))}
    </Collapsible>
  )
}

Categories.defaultProps = {
  selectedIndex: 0
}

Categories.propTypes = {
  categories: PropTypes.arrayOf(category).isRequired,
  selectedIndex: PropTypes.number
}
